import { InitPage } from "../index";
import swal from "sweetalert";

class RestPinDialog {
  constructor() {
    $(document).on('click', '#reset-pin-link', this.confirmation);
  }

  confirmation(e) {
    e.preventDefault();

    swal({
      title: "Are you sure?",
      text: "We will send a reset link to your email to help you recover your PIN. Are you sure you want to proceed?",
      icon: "warning",
      buttons: ["Cancel", "Reset"],
      dangerMode: true,
    }).then(function(willReset) {
      if (willReset) {
        $.ajax({
          url: '/users/pin/reset',
          method: 'POST',
          dataType: 'json',
          success: function(data) {
            if (data.ok) {
              swal("Success", "We've sent a PIN reset link to your email address.", "success");
            } else {
              swal("Error", data.message, "error");
            }
          },
          error: function() {
            swal("Error", "Network error. Please try again later.", "error");
          }
        });
      }
    });
  }
}

export function LoadPage() {
  new RestPinDialog();
}

